import { RichText, Text, Image } from '@sitecore-jss/sitecore-jss-react';
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';

const InvestByCategory = (props) => {
  useEffect(() => {
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl);
    });
  }, []);

  return (
    <>
      <section className="invest_by_category sec_padding_cm" id="investbycategory">
        <div className="invest_by_category_inner">
          <div className="cus-container">
            <div className="invest_by_cat_info">
              <div className="invest_by_cat_header">
                <h2 className="section-heading heading-flex text-center">
                  <span className="">
                    <RichText field={props?.fields?.heading} />
                  </span>
                </h2>
              </div>
              <div className="invest_cat_card">
                <div className="invest_cat_card_row">
                  {props?.fields?.Contents?.map((item, index) => {
                    const dynamicClass = `bb_color_style bb_color_style${(index % 4) + 1}`;
                    return (
                      <>
                        <div className="inv_card">
                          <a
                            href={item?.fields?.CTALink?.value?.href}
                            target={item?.fields?.CTALink?.value?.target}
                          >
                            <div className={`inv_card_inner ${dynamicClass}`}>
                              <div className="inv_card_img">
                                <Image
                                  className="inv_card_img--tag"
                                  width="100%"
                                  height="100%"
                                  field={item?.fields?.Image?.value}
                                  alt={item?.fields?.Image?.value?.alt}
                                  loading="lazy"
                                />
                              </div>
                              <div className="inv_card_content">
                                <h3 className="inv_card_title">
                                  <Text field={item?.fields?.Heading} />
                                  <span>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16.324"
                                      height="11.928"
                                      viewBox="0 0 16.324 11.928"
                                    >
                                      <path
                                        id="Path_25822"
                                        data-name="Path 25822"
                                        d="M96.25,104.779h.023c.185,0,.369,0,.554,0h12c-.225.225-.452.452-.677.679l-3.055,3.055a.668.668,0,0,0,.944.944l.008-.008c.2-.194.4-.4.592-.592q.608-.608,1.218-1.216l1.408-1.408,1.163-1.163c.162-.162.322-.324.484-.484a.658.658,0,0,0,.184-.37v0a.687.687,0,0,0-.107-.479.586.586,0,0,0-.077-.093l-.008-.008c-.194-.2-.4-.4-.592-.592l-1.216-1.216-1.408-1.408-1.163-1.163-.484-.484a.668.668,0,0,0-.944.944l.008.008c.194.2.4.4.592.592l2.621,2.623.509.509H96.25a.667.667,0,1,0,0,1.333Z"
                                        transform="translate(-95.182 -98.121)"
                                        fill="#333"
                                        stroke="#333"
                                        strokeWidth="0.8"
                                      />
                                    </svg>
                                  </span>
                                </h3>
                                <p className="inv_card_para">
                                  <RichText field={item?.fields?.Description} editable />
                                </p>
                              </div>
                            </div>
                          </a>
                        </div>
                      </>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default InvestByCategory;
